import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTopicStart,
  getAllTopicsStart,
} from "../../redux/auto-complete/reducer";
import {
  selectTopicList,
  selectIsFetchingTopics,
  selectIsDeletingTopics,
} from "../../redux/auto-complete/selectors";
import usePaginationWrapper from "../general/usePaginationWrapper";

const useGetAllTopics = ({ subjectName }) => {
  const dispatch = useDispatch();
  const topics = useSelector(selectTopicList);
  const loadingTopics = useSelector(selectIsFetchingTopics);
  const isDeletingTopic = useSelector(selectIsDeletingTopics);
  const [paginatedList, setPaginatedList] = useState([]);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const {
    searchText,
    setSearchText,
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    setPageable,
    page,
    setPage,
    pageOptions,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const fetchTopics = useCallback(() => {
    const data = {
      key: subjectName,
      term: "topics",
      limit: 0,
    };
    dispatch(getAllTopicsStart(data));
  }, [dispatch, subjectName]);

  useEffect(() => {
    if (subjectName) {
      fetchTopics();
    }
  }, [fetchTopics, subjectName, fetch]);

  useEffect(() => {
    if (topics) {
      setPageable({
        total_elements: topics?.length,
        total_pages: Math.ceil(totalElements / limit),
        number_of_elements: limit,
      });
      setPaginatedList(topics?.slice(offset, offset + limit));
    }
    if (searchText) {
      let filtered = topics.filter((topic) => {
        return topic.toLowerCase().includes(searchText.toLowerCase());
      });
      setPageable({
        total_elements: filtered?.length,
        total_pages: Math.ceil(totalElements / limit),
        number_of_elements: limit,
      });
      setPaginatedList(filtered);
    }
  }, [limit, offset, searchText, setPageable, topics, totalElements]);

  const deleteTopic = (data) => {
    dispatch(deleteTopicStart(data));
  };

  return {
    topics,
    searchText,
    setSearchText,
    paginatedList,
    loadingTopics,
    pageOptions,
    totalElements,
    limit,
    setPage,
    setLimit,
    page,
    setOffset,
    deleteTopic,
    isDeletingTopic,
    refetch,
  };
};

export default useGetAllTopics;
